<!--//@*/*
    //    *RPD  App v0.91
    //    * Copyright (c) 2022, Blue Cover Six LLC .John Molt All rights reserved.
    //    Code licensed under contract To Reno Police Department / City of Reno, in perpetuity
    //    */
    //-->

<template>
  <v-container class="black--text">
    <banner></banner>
    <div id="whats-next">
      <v-row no-gutters class="whats-next d-flex justify-center">
        <v-col
          xs="12"
          sm="12"
          md="12"
          lg="9"
          class="alice d-flex flex-column wrap-fix"
        >
          <v-expansion-panels class="mt-4">
            <v-expansion-panel>
              <v-expansion-panel-header
                color="accent"
                class="alice text-uppercase"
              >
                Background Reqirements
              </v-expansion-panel-header>
              <v-expansion-panel-content class="accent lighten-5">
                Background Reqirements go here. Lorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                commodo consequat.
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header
                color="accent"
                class="alice text-uppercase"
              >
                Job Qualifications
              </v-expansion-panel-header>
              <v-expansion-panel-content class="accent lighten-5">
                Job Qualifications go here. Lorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                commodo consequat.
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header
                color="accent"
                class="alice text-uppercase"
              >
                Application Process
              </v-expansion-panel-header>
              <v-expansion-panel-content class="accent lighten-5">
                Application Process go here. Lorem ipsum dolor sit amet,
                consectetur adipiscing elit, sed do eiusmod tempor incididunt ut
                labore et dolore magna aliqua. Ut enim ad minim veniam, quis
                nostrud exercitation ullamco laboris nisi ut aliquip ex ea
                commodo consequat.
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-spacer></v-spacer>
        </v-col>
      </v-row>
    </div>
  </v-container>
</template>

<style lang="scss" scoped>
@import "../scss/site.scss";

/* o media q */
@media (min-width: 0px) {
  #whats-next {
    width: 100%;
    height: 100vh;
    background-color: #344e6b;
    margin-top: 33%;
  }

  .alice {
    color: aliceblue;
  }

  .whats-next .v-col {
    justify-content: flex-start;
  }

  .section1 span,
  .section1 h1,
  .section1 h2,
  .section2 h1,
  .section2 h2,
  .section2 h3,
  .section3 h1,
  .section3 h2,
  .section3 h3 {
    padding: 5%;
    text-shadow: 2px 2px 4px #000000;
  }

  .section1 h2,
  .section2 h2 {
    font-weight: 300;
  }
}

/* 768 media q */
@media (min-width: 768px) {
  #whats-next {
    margin-top: 0;
  }
  .section1 {
    background-color: transparent;
    background-image: url("../images/reno-hero_1920.png");
    background-size: cover;
  }

  .whats-next {
    margin-top: 7%;
  }
}

/* ipad lansdscape */
@media (min-width: 1024px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
}

/* 1025 media q */

@media (min-width: 1025px) {
  #whats-next {
    margin-top: 0;
  }
  .section1 {
    background-image: none;
  }

  .whats-next .v-col {
    justify-content: center;
    align-self: center;
  }

  .whats-next {
    margin-top: 10%;
    align-self: center;
  }
}

@media (min-width: 2048px) {
}
</style>

<script>
/* eslint-disable */
import { bus_common } from "../mixins/bus_common";
import banner from "./banner.vue";
export default {
  name: "postion3",
  components: {
    banner,
  },
  mixins: [bus_common],
  data() {
    return {};
  },
  methods: {
    message1() {
      alert("This button does nothing yet.");
    },
    init() {},
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
};
</script>
